
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grievance-redressal",
      function () {
        return require("private-next-pages/grievance-redressal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grievance-redressal"])
      });
    }
  